import { createReducer, on } from "@ngrx/store";
import {
  ADD_ACTION,
  ADD_ACTIONS,
  ADD_FINDING,
  ADD_FINDINGS,
  UPDATE_ACTION,
  UPDATE_ACTIONS,
  UPDATE_FINDING,
  UPDATE_FINDINGS,
} from "../actions/finding.action";
import { ActionModel, FindingDetails } from "../models/assesment.model";

const INITIAL_STATE_FINDING: FindingDetails = {};
const INITIAL_STATE_FINDINGS: FindingDetails[] = [];

const INITIAL_STATE_ACTION: ActionModel = {};
const INITIAL_STATE_ACTIONS: ActionModel[] = [];

export const FindingReducer = createReducer(
  INITIAL_STATE_FINDING,
  on(ADD_FINDING, (_, finding) => finding),
  on(UPDATE_FINDING, (state, { finding }) => ({ ...state, ...finding })),
);

export const FindingsReducer = createReducer(
  INITIAL_STATE_FINDINGS,
  on(ADD_FINDINGS, (_, { findings }) => findings),
  on(UPDATE_FINDINGS, (state, { finding }) => {
    let exists = false;
    let findings = state.map((stateAssesment) => {
      if (stateAssesment.id === finding.id) {
        exists = true;
        return { ...finding, ...stateAssesment };
      }
      return stateAssesment;
    });
    if (!exists) findings = [...findings, finding];
    return findings;
  }),
);

export const ActionReducer = createReducer(
  INITIAL_STATE_ACTION,
  on(ADD_ACTION, (_, action) => action),
  on(UPDATE_ACTION, (state, { action }) => ({ ...state, ...action })),
);

export const ActionsReducer = createReducer(
  INITIAL_STATE_ACTIONS,
  on(ADD_ACTIONS, (_, { actions }) => actions),
  on(UPDATE_ACTIONS, (state, { action }) => {
    let exists = false;
    let actions = state.map((stateAssesment) => {
      if (stateAssesment?.id === action?.id) {
        exists = true;
        return { ...action, ...stateAssesment };
      }
      return stateAssesment;
    });
    if (!exists) actions = [...actions, action];
    return actions;
  }),
);
